import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { hasError } from 'src/app/core/base/base';
import { UserService } from 'src/app/core/common-services/user.services';
import { FundManagerDataService } from 'src/app/core/data-services/identity/fund-managers.data.service';
import { JariValidators } from 'src/app/shared/shared/jari-validators';

@Component({
  selector: 'app-fund-manager-set-password',
  templateUrl: './fund-manager-set-password.component.html',
  styleUrls: ['./fund-manager-set-password.component.css']
})
export class FundManagerSetPasswordComponent implements OnInit {
email!:string;
setPasswordForm! :FormGroup;
showOtp=false;
newPassword!:string;
confirmPassword!:string;
hasError = hasError;


  constructor(
    private route:ActivatedRoute,
    private router:Router,
    private fundManagerDataService:FundManagerDataService,
    private userService:UserService,
  ){}
  ngOnInit(): void {
    if(this.userService.isLoggedIn()){
      this.userService.clearLocalStorage();
      window.location.reload();
    }
    this.initPasswordForm();
    this.route.paramMap.subscribe(params => {
      this.email = params.get('email')!;   
      this.fundManagerDataService.getFundManagerByEmail(this.email).subscribe({
        next:(res)=>{
          if(res.resource&&res.resource.isCompleteProfile)
            this.router.navigate(['/authentication/login']);
          else{
            
          }
        }
      })
    });
  }
  initPasswordForm() {
    this.setPasswordForm = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(12),Validators.pattern(JariValidators.validPasswordRegex)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]),
    },
      { validators: this.password.bind(this) });
  }

  password(group: AbstractControl): ValidationErrors | null {
    let pass = group.get('password')!.value;
    let confirmPass = group.get('confirmPassword')!.value;
    if (pass == confirmPass && pass.length == confirmPass.length) {
      return null;
    }
    return pass === confirmPass ? null : { passwordNotMatch: true };
  }
  goToOtp(){
this.newPassword=this.setPasswordForm.get('password')!.value;
this.confirmPassword=this.setPasswordForm.get('confirmPassword')!.value;
setTimeout(() => {
  this.showOtp=true;
}, 0);
  }
}
